import type { DashboardStatusCategory } from '@myapp/contract'

/** Order of the stack segments, legend rows and donut slices. */
export const DASHBOARD_CATEGORY_ORDER: readonly DashboardStatusCategory[] = [
  'COMPLETED',
  'PLANNED',
  'NOT_PLANNED',
  'FOLLOW_UP_REQUIRED',
  'NOT_REACHED',
]

export const DASHBOARD_CATEGORY_LABELS: Record<DashboardStatusCategory, string> = {
  COMPLETED: 'Abgeschlossen',
  PLANNED: 'Geplant',
  NOT_PLANNED: 'Nicht geplant',
  FOLLOW_UP_REQUIRED: 'Nachfolge erforderlich',
  NOT_REACHED: 'Nicht erreicht',
}

// The same colours as the work order statuses (entities/work-order/model/workOrderStatus.ts),
// so a status looks identical here and on the Aufträge.
export const DASHBOARD_CATEGORY_COLORS: Record<DashboardStatusCategory, string> = {
  COMPLETED: '#3BC67D',
  PLANNED: '#2EB5D9',
  NOT_PLANNED: '#9CA3AF',
  FOLLOW_UP_REQUIRED: '#ED9E42',
  NOT_REACHED: '#D64541',
}
